import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Shield } from 'lucide-react';

export const AgeVerification = ({ onVerified }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const verified = sessionStorage.getItem('ageVerified');
    if (!verified) {
      setShow(true);
    } else {
      onVerified();
    }
  }, [onVerified]);

  const handleVerify = (isAdult) => {
    if (isAdult) {
      sessionStorage.setItem('ageVerified', 'true');
      setShow(false);
      onVerified();
    } else {
      window.location.href = 'https://www.google.com';
    }
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.92)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '40px 48px',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
        border: '1px solid rgba(229, 231, 235, 0.8)'
      }}>
        {/* Icona Shield con 18+ */}
        <div style={{
          position: 'relative',
          width: '100px',
          height: '100px',
          margin: '0 auto 28px',
          background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 10px 25px rgba(8, 145, 178, 0.3)',
          transform: 'rotate(-5deg)'
        }}>
          <span style={{
            fontSize: '48px',
            fontWeight: 'bold',
            color: 'white',
            transform: 'rotate(5deg)'
          }}>18+</span>
        </div>
        
        {/* Titolo */}
        <h2 style={{
          fontSize: '26px',
          fontWeight: '700',
          color: '#0f172a',
          marginBottom: '12px',
          letterSpacing: '-0.5px'
        }}>
          Verifica Età Richiesta
        </h2>
        
        {/* Testo descrittivo */}
        <p style={{
          fontSize: '15px',
          color: '#64748b',
          lineHeight: '1.6',
          marginBottom: '28px'
        }}>
          Conferma di avere almeno 18 anni per accedere<br />
          ai contenuti di questo sito web
        </p>

        {/* Pulsanti */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px'
        }}>
          <Button 
            size="lg"
            onClick={() => handleVerify(true)}
            style={{
              background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              padding: '14px 28px',
              borderRadius: '10px',
              border: 'none',
              cursor: 'pointer',
              textTransform: 'none',
              letterSpacing: '0.3px',
              width: '100%',
              transition: 'all 0.3s',
              boxShadow: '0 4px 12px rgba(8, 145, 178, 0.25)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(8, 145, 178, 0.35)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(8, 145, 178, 0.25)';
            }}
          >
            ✓ Ho più di 18 anni
          </Button>
          
          <Button 
            size="lg"
            variant="outline"
            onClick={() => handleVerify(false)}
            style={{
              backgroundColor: 'white',
              color: '#64748b',
              fontSize: '14px',
              fontWeight: '500',
              padding: '14px 28px',
              borderRadius: '10px',
              border: '2px solid #e2e8f0',
              cursor: 'pointer',
              textTransform: 'none',
              letterSpacing: '0.3px',
              width: '100%',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f8fafc';
              e.target.style.borderColor = '#cbd5e1';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.borderColor = '#e2e8f0';
            }}
          >
            ✗ Ho meno di 18 anni
          </Button>
        </div>

        {/* Testo legale */}
        <p style={{
          fontSize: '11px',
          color: '#94a3b8',
          marginTop: '20px',
          lineHeight: '1.5',
          borderTop: '1px solid #f1f5f9',
          paddingTop: '16px'
        }}>
          Vendita vietata ai minori di 18 anni • Legge italiana
        </p>
      </div>
    </div>
  );
};
